export const GET_TEMPLATE = 'GET_TEMPLATES';
export const UPDATE_TEMPLATE = 'UPDATE_TEMPLATE';
export const QUERY_TEMPLATES = 'QUERY_TEMPLATES';
export const REDUCE_TEMPLATES = 'REDUCE_TEMPLATES';
export const REDUCE_TEMPLATE = 'REDUCE_TEMPLATE';
